import { SelectPicker } from "../custom-packages/choicesjs/selectPicker";

export enum UserDocumentType {
    Kvk = 0, // KVK uitreksel
    CompanyDebitCard = 1, // Bankpas op naam van bedrijf
    LiabilityInsurance = 2, // Aansprakelijkheidsverzekering
    HealthInsurance = 3, // Zorgverzekering
    DisabilityInsurance = 4, // Arbeidsongeschiktheidsverzekering
    TaxAuthorityEntrepeneurTest = 6, // Ondernemerscheck Belastingdienst
    BsnForm = 7, // BSN-formulier wanneer niet uit NL
    DrivingLicense = 8, // Rijbewijs
    VcaCertificaat = 9, // VCA certificaat
    VcaVol = 10, // VCA-VOL
    Gpi = 11, // GPI
    VOG = 12, // VOG
    Nen3140 = 13, // NEN3140
    Atex = 14, // ATEX
    VatId = 15 // BTW-id
}

export enum UserDocumentStatus {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
    Expired = 3
}

export class UserDocumentModel {
    label: string;
    type: UserDocumentType;
}

export function getUserDocumentString(type: UserDocumentType): string {
    switch (type) {
        case UserDocumentType.Kvk:
            return "KVK uittreksel";
        case UserDocumentType.CompanyDebitCard:
            return "Bankpas op naam van bedrijf";
        case UserDocumentType.LiabilityInsurance:
            return "Aansprakelijkheidsverzekering";
        case UserDocumentType.HealthInsurance:
            return "Zorgverzekering";
        case UserDocumentType.DisabilityInsurance:
            return "Arbeidsongeschiktheidsverzekering";
        case UserDocumentType.TaxAuthorityEntrepeneurTest:
            return "Ondernemerscheck Belastingdienst";
        case UserDocumentType.BsnForm:
            return "BSN-formulier";
        case UserDocumentType.DrivingLicense:
            return 'Rijbewijs';
        case UserDocumentType.VcaCertificaat:
            return 'VCA certificaat';
        case UserDocumentType.VcaVol:
            return 'VCA-VOL';
        case UserDocumentType.Gpi:
            return 'GPI';
        case UserDocumentType.VOG:
            return 'VOG';
        case UserDocumentType.Nen3140:
            return 'NEN3140';
        case UserDocumentType.Atex:
            return 'ATEX';
        case UserDocumentType.VatId:
            return 'BTW-id';
        default:
            return "Onbekend";
    }
}

export function getUserDocumentOptions(): Array<SelectPicker> {
    return [
        { value: UserDocumentType.DisabilityInsurance.toString(), label: getUserDocumentString(UserDocumentType.DisabilityInsurance) },
        { value: UserDocumentType.BsnForm.toString(), label: getUserDocumentString(UserDocumentType.BsnForm) },
        { value: UserDocumentType.DrivingLicense.toString(), label: getUserDocumentString(UserDocumentType.DrivingLicense) },
        { value: UserDocumentType.VcaCertificaat.toString(), label: getUserDocumentString(UserDocumentType.VcaCertificaat) },
        { value: UserDocumentType.VcaVol.toString(), label: getUserDocumentString(UserDocumentType.VcaVol) },
        { value: UserDocumentType.Gpi.toString(), label: getUserDocumentString(UserDocumentType.Gpi) },
        { value: UserDocumentType.VOG.toString(), label: getUserDocumentString(UserDocumentType.VOG) },
        { value: UserDocumentType.Nen3140.toString(), label: getUserDocumentString(UserDocumentType.Nen3140) },
        { value: UserDocumentType.Atex.toString(), label: getUserDocumentString(UserDocumentType.Atex) },
        { value: UserDocumentType.VatId.toString(), label: getUserDocumentString(UserDocumentType.VatId) }
    ];
}

export function getAllUserDocuments(): Array<UserDocumentModel> {
    return Object.entries(UserDocumentType)
        .filter(([_, value]) => typeof value === 'number')
        .map(([_, value]) => ({
            type: value as UserDocumentType,
            label: getUserDocumentString(value as UserDocumentType)
        }));
}
